import { z } from 'zod';

export const LinkPreviewRequestDto = z.object({
  url: z.string().url(),
});

export type ApiLinkPreviewRequestDto = z.infer<typeof LinkPreviewRequestDto>;

export const LinkPreviewResponseSchema = z.object({
  status: z.enum(['ready', 'unavailable']),
  url: z.string().url(),
  title: z.string().nullable(),
  imageUrl: z.string().url().nullable(),
});

export type ApiLinkPreviewResponseDto = z.infer<
  typeof LinkPreviewResponseSchema
>;
